export class Base64DecoderService {
  decode(data) {
    return atob(data);
  }
}
